import { ReactNode } from 'react';

/**
 * The page's signature element: a hand-stamped "filed & approved" seal.
 * Used for trust markers on the homepage, the hero accent, and completed
 * order states — anywhere the emotional payoff is "this is officially done."
 */
export function SealBadge({
  children,
  size = 'md',
  rotate = true,
}: {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  rotate?: boolean;
}) {
  const sizeClasses = {
    sm: 'w-16 h-16 text-[10px]',
    md: 'w-24 h-24 text-xs',
    lg: 'w-36 h-36 text-sm',
  }[size];

  return (
    <div
      className={`seal-badge ${sizeClasses} flex-col text-center font-display font-semibold uppercase tracking-wide text-seal-blue leading-tight p-2`}
      style={rotate ? { transform: 'rotate(-3deg)' } : undefined}
    >
      {children}
    </div>
  );
}
